/* eslint-disable @next/next/no-img-element */
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { DEALS_CONFIG } from '../../../../brands/default/config';
import {
  replaceImageServer,
  usePlaceholderImage,
} from '../../../../helpers/image';
import { showVideo } from '../../../../helpers/video';
import ThemeContext from '../../../../providers/ThemeProvider';

const CarouselArrow = dynamic(
  () => import('../carousel-common/CarouselArrow'),
  {
    ssr: false,
  },
);

const CarouselThumb = ({
  index = 0,
  deal = {},
  image = {},
  onSelect = () => false,
  showMore = null,
  showMoreOnClick = () => null,
}) => {
  const theme = useContext(ThemeContext);
  const hidePlayIcon = index || !deal || !showVideo(deal);
  const showMoreBlock = (
    <>
      <a
        className="thumb__button"
        href=""
        onClick={(event) => {
          event.preventDefault();
          showMoreOnClick();
        }}
        role="button"
      >
        <div className="show-more">
          <div className="show-more-text">
            <span className="show-more-photo-count">{`+${showMore}`}</span>
            <span className="show-more-text-photos">
              {showMore > 1 ? ' photos' : 'photo'}
            </span>
          </div>
          <div className="show-more-arrow">
            <CarouselArrow
              extraClasses="carousel-thumbs-next-arrow"
              orientation="next"
            />
          </div>
        </div>
      </a>
      <style jsx>
        {`
          .show-more {
            align-items: center;
            background: rgba(0, 0, 0, 0.5);
            bottom: 0;
            display: flex;
            color: white;
            font-size: 13px;
            left: 0;
            position: absolute;
            right: 0;
            justify-content: space-around;
            top: 0;
          }
          .show-more-text {
            display: flex;
          }
          .show-more-text-photos {
            display: none;
          }

          @media (min-width: ${theme.breakpoints.lgUp}) {
            .show-more-text-photos {
              margin-left: 2px;
              display: block;
            }
          }
        `}
      </style>
    </>
  );

  return (
    <>
      <li className="thumb">
        {showMore && showMoreBlock}
        <button
          className="thumb__button"
          onClick={() => onSelect(index)}
          tabIndex={-1}
          type="button"
        >
          {!hidePlayIcon && !showMore && (
            <FontAwesomeIcon
              icon={faPlayCircle}
              style={{ height: 20, width: 20 }}
            />
          )}
          <img
            alt={image.alt}
            className="thumb__image img-fluid"
            onError={usePlaceholderImage}
            src={replaceImageServer({
              dealId: deal.id,
              height: DEALS_CONFIG.TRAVEL_DEAL_IMG_HEIGHT_THUMB,
              image,
              width: DEALS_CONFIG.TRAVEL_DEAL_IMG_WIDTH_THUMB,
            })}
          />
        </button>
      </li>
      <style jsx>{`
        .thumb {
          position: relative;
          margin: 7px 0 0 8px;
        }
        .thumb:first-child {
          margin-left: 0;
        }
        :global(.thumb__button) {
          color: ${theme.colors.white};
          cursor: pointer;
          border: none;
          background-color: transparent;
          padding: 0;
        }
        .thumb__button:hover,
        .thumb__button:focus {
          outline: none;
        }
        :global(.thumb__image) {
          width: 73px;
        }
        :global(.thumb svg) {
          color: ${theme.colors.dealvideoicon};
          filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
          position: absolute;
          top: 9px;
          left: 9px;
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          :global(.thumb__image) {
            width: 120px;
          }
        }
      `}</style>
    </>
  );
};

CarouselThumb.propTypes = {
  deal: PropTypes.object,
  image: PropTypes.object,
  index: PropTypes.number,
  onSelect: PropTypes.func,
  showMore: PropTypes.number,
  showMoreOnClick: PropTypes.func,
};

export default CarouselThumb;
